import React from 'react';
import PortfolioDetailsContent from '../elements/portfolio/PortfolioDetailsContent';
import PortfolioData from '../data/portfolio/PortfolioData.json';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import ErrorPage from './Error';

const SITE_URL = 'https://www.blackwave.augustow.pl';

const PortfolioDetails = ({ portfolioId: portfolioIdProp }) => {
    const portfolioId = Number.parseInt(String(portfolioIdProp), 10);
    const data = PortfolioData.find((portfolio) => portfolio.id === portfolioId);

    if (!data) return <ErrorPage />;

    const canonicalPath = `/portfolio-details/${portfolioId}`;
    const numericPrice = data.date.replace(/[^0-9.,]/g, '').replace(',', '.');

    const serviceSchema = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        '@id': `${SITE_URL}${canonicalPath}#service`,
        name: `Wynajem ${data.title} w Augustowie`,
        description: data.shortDescription || data.excerpt,
        url: `${SITE_URL}${canonicalPath}`,
        image: [
            `${SITE_URL}/${data.largeImage.replace(/^\.\//, '')}`,
            `${SITE_URL}/${data.gallery.imageOne.replace(/^\.\//, '')}`,
            `${SITE_URL}/${data.gallery.imageTwo.replace(/^\.\//, '')}`,
            `${SITE_URL}/${data.gallery.imageThree.replace(/^\.\//, '')}`,
        ],
        provider: { '@id': `${SITE_URL}/#business` },
        areaServed: [
            { '@type': 'City', name: 'Augustów' },
            { '@type': 'Place', name: 'Jezioro Białe Augustowskie' },
            { '@type': 'Place', name: 'Jezioro Necko' },
        ],
        offers: {
            '@type': 'Offer',
            priceCurrency: 'PLN',
            price: numericPrice,
            url: `${SITE_URL}${canonicalPath}`,
            availability: 'https://schema.org/InStock',
            description: `Cena wynajmu ${data.title} na 2 godziny.`,
        },
        additionalProperty: [
            { '@type': 'PropertyValue', name: 'Pojemność', value: data.capacity },
            { '@type': 'PropertyValue', name: 'Długość', value: data.length },
            { '@type': 'PropertyValue', name: 'Silnik', value: data.engine },
        ],
    };

    const breadcrumbSchema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
            {
                '@type': 'ListItem',
                position: 1,
                name: 'BlackWave',
                item: `${SITE_URL}/`,
            },
            {
                '@type': 'ListItem',
                position: 2,
                name: 'Flota',
                item: `${SITE_URL}/#pricing`,
            },
            {
                '@type': 'ListItem',
                position: 3,
                name: data.title,
                item: `${SITE_URL}${canonicalPath}`,
            },
        ],
    };

    return (
        <>
            <SEO
                title={`${data.title} — wynajem motorówki Augustów | BlackWave`}
                description={`${data.shortDescription || data.excerpt} ${data.capacity}, ${data.engine}. Wynajem w Augustowie — Jezioro Białe i Necko.`}
                canonicalPath={canonicalPath}
                image={`${SITE_URL}/${data.largeImage.replace(/^\.\//, '')}`}
                type="website"
                structuredData={[serviceSchema, breadcrumbSchema]}
                preloadImage={`${SITE_URL}/${data.largeImage.replace(/^\.\//, '')}`}
                preloadType="image/webp"
            />
            <Layout>
                <PortfolioDetailsContent data={data} />
            </Layout>
        </>
    );
};

export default PortfolioDetails;
